var _path;
import { jsx as _jsx } from "react/jsx-runtime";
var PaperPlane = function PaperPlane(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'tw-text-neutral-light-800' : _ref$className,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 32 : _ref$size;
  return /*#__PURE__*/_jsx("svg", {
    className: className,
    width: size,
    height: size,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      fillRule: "evenodd",
      clipRule: "evenodd",
      d: "M21.065 2.002a1 1 0 0 1 .867 1.36L15.44 21.34a1.55 1.55 0 0 1-2.84.096l-3.345-6.69-6.69-3.346a1.55 1.55 0 0 1 .095-2.84l17.98-6.493a.999.999 0 0 1 .425-.065Zm-3.943 3.461-12.75 4.605 5.43 2.715 7.32-7.32Zm-5.905 8.735 7.32-7.32-4.605 12.75-2.715-5.43Z",
      fill: "none",
      className: "tw-fill-current"
    }))
  });
};
export default PaperPlane;